
global.modules.set({
  initAssetTypesForm() {
    var value = $('#listing_form, #want_form').find('[name="asset_type_id"]').val();
    if (value == window.businessForSaleId) {
      $('.bussiness_for_sale').show();
      $('.bussiness_for_sale').find('[name]').prop('disabled', false);
      $('.other_asset_types').find('[name]').prop('disabled', true);
      $('.other_asset_types').hide();
    } else {
      $('.bussiness_for_sale').hide();
      $('.bussiness_for_sale').find('[name]').prop('disabled', true);
      $('.other_asset_types').find('[name]').prop('disabled', false);
      $('.other_asset_types').show();
    }
    if ([window.agriculturalId, window.landId].includes(Number(value))) {
      $('.size_area').attr('placeholder', "ACRES");
    } else {
      $('.size_area').attr('placeholder', "SQFT");
    }
  },
  initPriceRent() {
    var value = $('#listing_form, #want_form').find('[name="trade_type_id"]').val();
    var dealType = window.dealTypes.find(function (el) {
      return el.id == value;
    });
    if (dealType && dealType.requires_rent) {
      $('#rent').show();
    } else {
      $('#rent').hide();
      $('#rent').find('input').val('');
    }
    if (dealType && dealType.requires_price) {
      $('#price').show();
    } else {
      $('#price').hide();
      $('#price').find('input').val('');
    }
  },
  async init(context) {
    global.validateForm({
      selector: '#listing_form',
      rules: {
        name: 'required'
      }
    })

    global.validateForm({
      selector: '#want_form',
      rules: {
        name: 'required'
      }
    })

    $('#listing_form, #want_form', context).find('[name="trade_type_id"]').on('change', this.initPriceRent);
    $('#listing_form, #want_form', context).find('[name="asset_type_id"]').on('change', this.initAssetTypesForm);

    $('[name="data.leased_owned"]', context).on('change', function () {
      var val = $(this).val();
      if (val == 'leased') {
        $('.owned').hide();
        $('.owned').find('[name]').attr('disabled', true);
        $('.leased').show();
        $('.leased').find('[name]').removeAttr('disabled');
      }
      if (val == 'owned') {
        $('.owned').show();
        $('.owned').find('[name]').removeAttr('disabled');
        $('.leased').hide();
        $('.leased').find('[name]').attr('disabled', true);
      }
    })

    $('[name="data.asking_price_included"]').on('change', function () {
      $('[name="data.inventory"]').val('');
    })

    $('[name="data.inventory"]').on('input', function () {
      $('[name="data.asking_price_included"]').attr('checked', false).parent().removeClass('active');
    })

    $('.documents.repeater').on('init_repeater add_row', function () {
      var row = $(this).find('.repeater_row').last()
      row.find('input[type="file"]').trigger('click');
      row.find('.filename').text('Click to add file');
      row.find('input[type="file"]')
        .on('input', function () {
          console.log('input');
          row.find('.filename').text(this.files[0].name);
          return true;
        })
      document.body.onfocus = function () {
        setTimeout(function () {
          if (!row.find('input[type="file"]')?.[0]?.files?.length) row.remove()
          document.body.onfocus = null;
        }, 550)
      }
    })

    $('.documents.repeater').find('label').on('click', function () {
      var repeater = $(this).closest('.repeater');
      var row = $(this).closest('.repeater_row');
      row.find('input[type="hidden"]')
        .attr('type', 'file')
        .removeAttr('disabled')
        .attr('name', $(repeater.get()[0].template).find('input[type="file"]').attr('name').split('[]').join(`[${repeater.find('.rows').children().length}]`));
      row.find('input[type="file"]').on('input', function () {
        row.find('.filename').text(this.files[0].name)
      })
    })

    if (window.dealTypes) {
      this.initPriceRent();
    }
    this.initAssetTypesForm();
  }
})


